/**
 * @module app.user.welcome
 */

import appBase from '../index.js';


class Controller {

  /**
   * @param {app.AuthenticationService} appAuthenticationService
   * @param {angularGettext.Catalog} gettextCatalog Gettext catalog.
   * @ngInject
   */
  constructor(appAuthenticationService, gettextCatalog) {
    /**
     * @private
     */
    this.authentication_ = appAuthenticationService;

    this.loginConfig = this.authentication_.loginConfig;

    /**
     * @type {angularGettext.Catalog}
     */
    this.gettextCatalog = gettextCatalog;
  }

  /**
   * @export
   */
  logout() {
    this.authentication_.logout();
  }

}

/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'drawNewTrack': '&',
    'userData': '<'
  },
  controller: Controller,
  templateUrl: 'js/app/user/welcome/partial.html'
};

export default appBase.component('appUserWelcome', component);
